export default "__VITE_ASSET__CJSdomqt__"